import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // 페이지 이동 시 스크롤 위치를 저장
    if (window.history.state && window.history.state.usr) {
      const { scrollY } = window.history.state.usr;
      setTimeout(() => {
        window.scrollTo(0, scrollY);
      }, 0);
    }

    // popstate 이벤트 리스너 추가
    const handlePopState = () => {
      if (window.history.state && window.history.state.usr) {
        const { scrollY } = window.history.state.usr;
        window.scrollTo(0, scrollY);
      }
    };

    window.addEventListener('popstate', handlePopState);

    // 현재 스크롤 위치를 history state에 저장
    const saveScrollPosition = () => {
      const state = window.history.state || {};
      window.history.replaceState(
        {
          ...state,
          usr: { ...state.usr, scrollY: window.scrollY }
        },
        ''
      );
    };

    window.addEventListener('scroll', saveScrollPosition);

    return () => {
      window.removeEventListener('popstate', handlePopState);
      window.removeEventListener('scroll', saveScrollPosition);
    };
  }, [pathname]);

  return null;
}

export default ScrollToTop; 